module.exports = __webpack_public_path__ + "static/img/cangku4.b8c570f3.png";